import { Component, ViewChild, Input } from '@angular/core';
import * as $ from 'jquery'

@Component({
  selector: 'rmt-new-entry',
  templateUrl: 'rmt-new-entry.html'
})
export class RmtNewEntryComponent {
  @Input() start: boolean = true;
  @Input() menuSelected: string;
  @Input() transitionPromise;
  @ViewChild('newEntry') newEntry;
  init: boolean = false;
  hasStarted: boolean = false;

  constructor() {
  }

  ngAfterViewInit() {
    this.init = true;
    if (this.start && !this.hasStarted)
      this.animate();
  }

  ngOnChanges() {
    if(this.menuSelected && this.init && this.start) {
      if(this.newEntry) {
        this.newEntry.nativeElement.style.opacity = 0;
        this.newEntry.nativeElement.style.maxHeight = '0px';
      }
      this.animate();
    }
    else if (this.init && this.start && !this.hasStarted)
      this.animate();
  }

  animate() {    
    RmtNewEntryComponent.pendingAnimations(this, this.transitionPromise);    
    this.hasStarted = true;
    window.setTimeout(() => {
      if (this.newEntry) {        
        $(this.newEntry.nativeElement).addClass('anim-fadein');
        this.newEntry.nativeElement.style.opacity = 1.0;
        this.newEntry.nativeElement.style.maxHeight = '300px';        
        window.setTimeout(() => {
          $(this.newEntry.nativeElement).removeClass('anim-fadein');          
          RmtNewEntryComponent.finishAnimations(this, this.transitionPromise);
        }, 600);
      }
      else
        RmtNewEntryComponent.finishAnimations(this, this.transitionPromise);
    }, 500);
  }

  static pendingAnimations(anim, promise) {
    if (!promise)
      return;
    if (!promise.pending)
      promise.pending = [];
    if (promise.pending.indexOf(anim) === -1)
      promise.pending.push(anim);
    if (!promise.promise)
      promise.promise = new Promise((resolve) => {
        promise.resolve = resolve;
      });
  }

  static finishAnimations(anim, promise) {
    if (!promise)
      return;
    let finished = false;
    if (promise.pending) {
      const pos = promise.pending.indexOf(anim);
      if (pos !== -1)
        promise.pending.splice(pos, 1);
      if (promise.pending.length === 0)
        finished = true;
    }
    else
      finished = true;

    if (finished && promise.resolve) {
      promise.resolve();
      promise.resolve = null;
      promise.promise = null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/rmt-new-entry/rmt-new-entry.ts